// extracted by mini-css-extract-plugin
module.exports = {"banner":"_1U03K"};